module.exports = __webpack_public_path__ + "static/media/pedidos-logo.7002e1b8.png";